import { FileWithPath } from '@mantine/dropzone'
import axios from 'axios'

interface IUploadCroppedPhoto {
  id: number
  file: string | FileWithPath
}

export const UploadPromotionPhoto = async ({ id, file }: IUploadCroppedPhoto) => {
  const tokenString = localStorage.getItem('token')
  const accessToken = JSON.parse(tokenString as string).access_token

  const formData = new FormData()
  formData.append('file', file)

  const result = await axios.post<string>(
    `${import.meta.env.VITE_API_URL}photo/Promotion/${id}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
    },
  )
  return result
}
